import angular from 'angular'

import MyRenaultResolver from './my-renault.resolver'

const MYRENAULT_ERROR_CODES = {
  TOKEN_EXPIRED: 1,
  545: 1, // LsfErrorType.TOKEN_MYRENAULT_EXPIRED
  552: 1, // LsfErrorType.TOKEN_MYRENAULT_WRONGDATEFORMAT
  INVALID_SIGNATURE: 2,
  546: 2, // LsfErrorType.TOKEN_MYRENAULT_SIGNATURE_INVALID
  UNKNOWN_EMAIL: 3,
  524: 3, // LsfErrorType.USER_NOT_FOUND
  508: 3, // LsfErrorType.LOGIN_FAILED
  VIN_EMAIL_ASSOCIATION: 4,
  TOKEN_NOT_PRESENT: 5,
  551: 5, // LsfErrorType.TOKEN_MYRENAULT_NOTPRESENT
  SESSION_TIMEOUT: 6,
  VIN_NOT_PRESENT: 7,
  VIN_IS_NULL: 8,
  UNKNOWN_VIN: 9,
  594: 9 // LsfErrorType.UNKNOWN_VIN
}

let module = angular.module('myRenault', [])

// Keep MyRenault token between pages
.run(($transitions, $location, MyRenaultResolver, Localization, $window) => {
  'ngInject'
  if (MyRenaultResolver.isMyRenault()) {
    let token

    $transitions.onBefore(
      {to: (state) => state.myRenaultForbidden},
      (trans) => {
        $window.top.location.href = Localization.getLocalizedAppConfig().errorUrl + '403'
      }
    )

    $transitions.onStart({}, (trans) => {
      token = $location.search().token
    })

    $transitions.onSuccess({}, (trans) => {
      $location.search('token', token)
    })
  }
})

.service('MyRenaultResolver', MyRenaultResolver)

.constant('MyRenaultErrorCodes', MYRENAULT_ERROR_CODES)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/my-renault/index.js